namespace Gamification.Gamification {
    export class RisorseCheckColumns {
        static columnsKey = 'Gamification.RisorseCheck';
    }
}
